<template>
  <div class="cf-page-container">
    <div class="cf-card cf-card--mobile cf-flex cf-flex--column cf-flex--gap-16">
      <h1 class="cf-title cf-title--1">
        {{ userNameTitleMessage }}
      </h1>

      <div class="cf-container-full-width cf-flex cf-flex--justify-center">
        <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-max-width-600">
          <cf-loading-wrapper
            :is-loading="isLoading"
            :loader-type="'section'"
          >
            <div
              ref="giftCardScanCarousel"
              class="carousel__items"
            >
              <cf-gift-card-payment-method
                v-for="giftCard in giftCardPaymentMethods"
                :key="giftCard.cardId"
                :focused-payment-method-idx="focusedCard"
                :gift-card="giftCard"
              />

              <div class="cf-carousel__item">
                <cf-add-payment-method :is-credit-card-add-enabled="false" />
              </div>
            </div>
          </cf-loading-wrapper>

          <!-- Page Dots -->
          <div
            v-if="numberOfDots > 1"
            class="cf-carousel__dots"
          >
            <div
              v-for="(_, idx) in numberOfDots"
              :key="idx"
              :class="['cf-carousel__dot', { 'cf-carousel__dot--active': idx === focusedCard }]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';

  import CfGiftCardPaymentMethod from './cf-gift-card-payment-method/index.vue';

  import CfAddPaymentMethod from '@/view/components/globals/cf-add-payment-method/index.vue';
  import CfLoadingWrapper from '@/view/components/globals/cf-loading-wrapper/index.vue';


  export default {
    name: 'ScanToPay',

    components: {
      CfGiftCardPaymentMethod,
      CfLoadingWrapper,
      CfAddPaymentMethod
    },

    data() {
      return {
        isLoading: false,
        focusedCard: 0
      };
    },

    computed: {
      ...mapGetters('offers', ['loyalty', 'offers']),
      ...mapGetters('session', ['currentUser']),
      ...mapGetters('locations', ['timeZone']),

      ...mapGetters('savedCards', ['savedCards']),
      ...mapGetters('giftCards', ['giftCards']),

      userNameTitleMessage() {
        return `Hello ${this.currentUser.fullName}`;
      },

      giftCardPaymentMethods() {
        return this.giftCards.savedCards;
      },

      numberOfDots() {
        /** Need to add 1 to account for final "add method" card */
        return this.giftCardPaymentMethods.length + 1;
      },

      isScrolledToAddPaymentMethodCard() {
        return this.focusedCard === this.giftCardPaymentMethods.length;
      }
    },

    watch: {
      'giftCards.cards': { handler: 'giftCardsChangeWatcher', immediate: false }
    },

    created() {
      this.onComponentCreated();
    },

    beforeUnmount() {
      this.beforeDestroyHandler();
    },

    methods: {
      async onComponentCreated() {
        await this.getSavedCards();

        this.$refs.giftCardScanCarousel.addEventListener('scroll', this.scrollHandler);
      },

      beforeDestroyHandler() {
        this.$refs.giftCardScanCarousel.removeEventListener('scroll', this.scrollHandler);
      },

      async getSavedCards() {
        this.isLoading = true;

        try {
          await this.$store.dispatch('giftCards/getSavedCards');
        }
        catch (error) {
          errorHandlers.generic(error);
        }
        finally {
          this.isLoading = false;
        }
      },

      scrollHandler() {
        const itemWidth = this.$refs.giftCardScanCarousel.children[0].clientWidth;
        const containerWidth = this.$refs.giftCardScanCarousel.scrollWidth;
        const scrolled = this.$refs.giftCardScanCarousel.scrollLeft;
        const items = containerWidth / itemWidth;
        const result = (scrolled / containerWidth) * items;

        if (Number.isInteger(result)) {
          this.focusedCard = result;
        }
      },

      giftCardsChangeWatcher(newCards, oldCards) {
        const hasNewCard = newCards.length > oldCards.length;

        if (hasNewCard && this.$refs.giftCardScanCarousel) {
          this.$nextTick(() => {
            const scrollToIndex = !oldCards.length
              ? 0 /* scroll to first gift card if no old cards */
              : newCards.findIndex(newCard => !oldCards.some(oldCard => oldCard.cardId === newCard.cardId));

            this.$refs.giftCardScanCarousel.children[scrollToIndex].scrollIntoView({ behavior: 'smooth' });
          });
        }
      }
    }
  };
</script>
